import { render, staticRenderFns } from "./TableListQualification.vue?vue&type=template&id=38a70231"
import script from "./TableListQualification.vue?vue&type=script&lang=js"
export * from "./TableListQualification.vue?vue&type=script&lang=js"
import style0 from "./TableListQualification.vue?vue&type=style&index=0&id=38a70231&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports